<template>
	<div>
		<InfoForm :customerId="queryObj.customerId" :tuId="queryObj.tuId" :sourceType="queryObj.sourceType" />
	</div>
</template>

<script>
import InfoForm from "@/components/CustomerInfo/info";
export default {
	components: {
		InfoForm
	},
	data() {
		return {
			queryObj: {
				customerId: '',
				tuId: '',
				sourceType: ''
			}
		}
	},
	// watch: {
	// 	$route: {
	// 		hander(data) {
	// 			console.log('=====111====')
	// 			console.log(this.$route.query)
	// 			console.log(data)
	// 			this.queryObj = Object.assign(this.queryObj, data);
	// 			console.log(this.queryObj)
	// 			console.log('=====111====')
	// 		},
	// 		deep: true,
	// 		immediate:true
	// 	}
	// },
	mounted() {
		console.log('=====222====')
		console.log(this.$route.query)
		this.queryObj = Object.assign(this.queryObj, this.$route.query);
		console.log(this.queryObj)
		console.log('=====222====')
	}
}
</script>